import React from 'react';
import PropTypes from 'prop-types';
import Radio from '../Radio/Radio';
import './RadioGroup.scss';
import Icon from '../Icon/Icon';
import { createClassList } from '../../utils/dom/class';

const RadioGroup = ({
  name,
  legend,
  onChange,
  options,
  legendModifier,
  isError,
  horizontal,
  condensed,
  classes,
}) => {
  const defaultClasses = ['axiom-radiogroup--set', 'field-set'];

  if (isError) {
    defaultClasses.push('field-set--error');
  }
  if (horizontal) {
    defaultClasses.push('field-set--horizontal');
  }
  if (condensed) {
    defaultClasses.push('field-set--condensed');
  }

  return (
    <fieldset
      className={createClassList({
        default: defaultClasses,
        custom: classes,
        required: [],
      })}
      data-testid='field-set'
      aria-required={legendModifier === 'required' ? true : undefined}
      aria-invalid={isError ? true : undefined}
    >
      <legend>
        <div>
          {isError && <Icon name='notice-error' />}
          {legendModifier === 'required' ? (
            <span className='field-set--required' aria-hidden='true'>
              *{' '}
            </span>
          ) : (
            ''
          )}
          {legend}
          {legendModifier === 'optional' ? (
            <span className='field-set--optional'>
              {' (Optional)'}
            </span>
          ) : (
            ''
          )}
        </div>
      </legend>
      <div className='axiom-radiogroup--radio-buttons field-set--radio-button-group'>
        {options.map((option) => (
          <Radio
            key={option.id}
            id={option.id}
            name={name}
            label={option.label}
            value={option.value}
            inputRef={option.inputRef}
            disabled={option.disabled}
            checked={option.checked}
            onChange={onChange}
            condensed={condensed}
          />
        ))}
      </div>
    </fieldset>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
      ]),
      condensed: PropTypes.bool,
    })
  ).isRequired,
  legendModifier: PropTypes.oneOf(['required', 'optional']),
  isError: PropTypes.bool,
  horizontal: PropTypes.bool,
  condensed: PropTypes.bool,
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

RadioGroup.defaultProps = {
  legendModifier: undefined,
  isError: false,
  horizontal: false,
  condensed: false,
  classes: [],
};

export default RadioGroup;
